import { NgModule } from '@angular/core'
import { HeaderComponent } from 'src/app/common/components/header/header.component'
import { DailyLogTutorialGuideMessageComponent } from 'src/app/pages/daily-log/components/daily-log-tutorial-guide-message/daily-log-tutorial-guide-message.component'
import { SharedModule } from 'src/app/shared/shared.module'
import { AdsenseInarticleComponent } from './adsense-inarticle/adsense-inarticle.component'
import { AdsenseInfeedComponent } from './adsense-infeed/adsense-infeed.component'
import { AnswerTypeExampleComponent } from './answer-type-example/answer-type-example.component'
import { AppInstallPageLoadingComponent } from './app-install-page-loading/app-install-page-loading.component'
import { AppleLoginButtonComponent } from './apple-login-button/apple-login-button.component'
import { AskCommentComponent } from './ask/ask-comment/ask-comment.component'
import { AskContentComponent } from './ask/ask-content/ask-content.component'
import { AskDetailComponent } from './ask/ask-detail/ask-detail.component'
import { AskProfileComponent } from './ask/ask-profile/ask-profile.component'
import { AskReactionComponent } from './ask/ask-reaction/ask-reaction.component'
import { BlockedCoupangAdComponent } from './blocked-coupang-ad/blocked-coupang-ad.component'
import { ButtonComponent } from './button/button.component'
import { ContentBlockedCoupangAdComponent } from './content-blocked-coupang-ad/content-blocked-coupang-ad.component'
import { ContentLoadingComponent } from './content-loading/content-loading.component'
import { CoupangAdComponent } from './coupang-ad/coupang-ad.component'
import { DailyLogContentCoverComponent } from './daily-log-content-cover/daily-log-content-cover.component'
import { DailyLogContentEditComponent } from './daily-log-content-edit/daily-log-content-edit.component'
import { DailyLogContentTextComponent } from './daily-log-content-text/daily-log-content-text.component'
import { DailyLogContentComponent } from './daily-log-content/daily-log-content.component'
import { DailyLogEmojiReactionComponent } from './daily-log-reaction/daily-log-emoji-reaction/daily-log-emoji-reaction.component'
import { DailyLogMemeReactionComponent } from './daily-log-reaction/daily-log-meme-reaction/daily-log-meme-reaction.component'
import { DailyLogMemoReactionComponent } from './daily-log-reaction/daily-log-memo-reaction/daily-log-memo-reaction.component'
import { DailyLogReactionComponent } from './daily-log-reaction/daily-log-reaction.component'
import { DailyLogStickerReactionComponent } from './daily-log-reaction/daily-log-sticker-reaction/daily-log-sticker-reaction.component'
import { DeveloperNoteComponent } from './developer-note/developer-note.component'
import { DividerComponent } from './divider/divider.component'
import { DrawerComponent } from './drawer/drawer.component'
import { ErrorComponent } from './error/error.component'
import { FeedbackQuestionComponent } from './feedback-question/feedback-question.component'
import { FeedbackComponent } from './feedback/feedback.component'
import { FooterComponent } from './footer/footer.component'
import { GoogleLoginButtonComponent } from './google-login-button/google-login-button.component'
import { HeaderInstallBannerComponent } from './header-install-banner/header-install-banner.component'
import { ContentHeaderComponent } from './header/content-header/content-header.component'
import { GnbHeaderComponent } from './header/gnb/gnb-header.component'
import { HeaderBaseComponent } from './header/header-base/header-base.component'
import { HeaderDrawerButtonComponent } from './header/header-drawer-button/header-drawer-button.component'
import { HeaderHomeButtonComponent } from './header/header-home-button/header-home-button.component'
import { HomeHeaderComponent } from './header/home-header/home-header.component'
import { MyHeaderComponent } from './header/my-header.component'
import { ProfileEditHeaderComponent } from './header/profile-edit-header.component'
import { DatingStyleComponent } from './ideal-type/ideal-type-dating-style/ideal-type-dating-style.component'
import { IdealTypeQuizMbtiDescriptionComponent } from './ideal-type/ideal-type-mbti-desciption/ideal-type-mbti-description.component'
import { IdealTypeQuizSurveyListComponent } from './ideal-type/ideal-type-survey-list/ideal-type-survey-list.component'
import { InputFieldComponent } from './input-field/input-field.component'
import { KakaoShareComponent } from './kakao-share/kakao-share.component'
import { LeadAppFooterComponent } from './lead-app-footer/lead-app-footer.component'
import { LocaleNameInput } from './locale-name-input/locale-name-input.component'
import { MbtiIdealTypeSelectComponent } from './mbti-ideal-type-select/mbti-ideal-type-select.component'
import { MbtiNeededComponent } from './mbti-needed/mbti-needed.component'
import { HorizontalQuestionComponent } from './mbti-question/horizontal-question/horizontal-question.component'
import { VerticalQuestionComponent } from './mbti-question/vertical-question/vertical-question.component'
import { MbtiSelectComponent } from './mbti-select/mbti-select.component'
import { MbtiTagComponent } from './mbti-tag/mbti-tag.component'
import { NoticeComponent } from './notice/notice.component'
import { PageLoadingComponent } from './page-loading/page-loading.component'
import { PageTitleComponent } from './page-title/page-title.component'
import { PercentStackedBarComponent } from './percent-stacked-bar/percent-stacked-bar.component'
import { PhoneInputComponent } from './phone-input/phone-input.component'
import { ProfileCardComponent } from './profile-card/profile-card.component'
import { ProfileImageComponent } from './profile-image/profile-image.component'
import { ProfileLogPostComponent } from './profile-log-post/profile-log-post.component'
import { ProgressBarComponent } from './progress-bar/progress-bar.component'
import { QuestionGroupCardComponent } from './question-group-card/question-group-card.component'
import { QuestionGroupSelectComponent } from './question-group-select/question-group-select.component'
import { DropdownQuestionComponent } from './question/dropdown-question/dropdown-question.component'
import { LinearQuestionFavourComparisonComponent } from './question/linear-question-favour-comparison/linear-question-favour-comparison.component'
import { LinearQuestionComponent } from './question/linear-question/linear-question.component'
import { MultiSelectQuestionComponent } from './question/multi-select-question/multi-select-question.component'
import { QuestionComponent } from './question/question.component'
import { SelectQuestionComponent } from './question/select-question/select-question.component'
import { SimpleNumberQuestionComponent } from './question/simple-number-question/simple-number-question.component'
import { SimpleTextQuestionComponent } from './question/simple-text-question/simple-text-question.component'
import { QuestionTickerComponent } from './question/ticker/ticker.component'
import { YearInputQuestionComponent } from './question/year-input-question/year-input-question.component'
import { QuizProfileRenewalComponent } from './quiz-profile-center/quiz-profile-renewal.component'
import { QuizProfileComponent } from './quiz-profile/quiz-profile.component'
import { MyMbtiGuestQuizReportCardComponent } from './quiz-report-card/my-answer-card/my-answer-card.component'
import { MyHostQuizReportCardComponent } from './quiz-report-card/my-quiz-card/my-quiz-card.component'
import { QuizReportCardComponent } from './quiz-report-card/quiz-report-card.component'
import { RecommendContentListComponent } from './recommend-quiz-list/recommend-content-list.component'
import { ResultSaveComponent } from './result-save/result-save.component'
import { ScreenContainerComponent } from './screen-container/screen-container.component'
import { SelectQuizReportComponent } from './select-quiz-report/select-quiz-report.component'
import { ShareLinearComponent } from './share-linear/share-linear.component'
import { SubtitleComponent } from './subtitle/subtitle.component'
import { SurveyCommentComponent } from './survey/survey-comment/survey-comment.component'
import { SurveyGraphComponent } from './survey/survey-graph/survey-graph.component'
import { SurveyProfileComponent } from './survey/survey-profile/survey-profile.component'
import { SurveyReactionComponent } from './survey/survey-reaction/survey-reaction.component'
import { TermLinkComponent } from './term-link/term-link.component'
import { TotalCountCounterComponent } from './total-count-counter/total-count-counter.component'

@NgModule({
  declarations: [
    AnswerTypeExampleComponent,
    ButtonComponent,
    ContentLoadingComponent,
    DividerComponent,
    ErrorComponent,
    FooterComponent,
    VerticalQuestionComponent,
    HorizontalQuestionComponent,
    NoticeComponent,
    PageLoadingComponent,
    PageTitleComponent,
    PercentStackedBarComponent,
    ProfileCardComponent,
    ProfileImageComponent,
    QuizReportCardComponent,
    SelectQuizReportComponent,
    SubtitleComponent,
    TermLinkComponent,
    MyHostQuizReportCardComponent,
    MyMbtiGuestQuizReportCardComponent,
    HeaderComponent,
    GnbHeaderComponent,
    MyHeaderComponent,
    ProfileEditHeaderComponent,
    HeaderHomeButtonComponent,
    FeedbackQuestionComponent,
    KakaoShareComponent,
    QuizProfileComponent,
    QuizProfileRenewalComponent,
    FeedbackComponent,
    DrawerComponent,
    LeadAppFooterComponent,
    QuestionComponent,
    SimpleTextQuestionComponent,
    SelectQuestionComponent,
    LinearQuestionComponent,
    MultiSelectQuestionComponent,
    SimpleNumberQuestionComponent,
    YearInputQuestionComponent,
    DropdownQuestionComponent,
    LinearQuestionFavourComparisonComponent,
    QuestionTickerComponent,
    PhoneInputComponent,
    InputFieldComponent,
    AskDetailComponent,
    AskContentComponent,
    AskCommentComponent,
    AskReactionComponent,
    AskProfileComponent,
    SurveyReactionComponent,
    SurveyProfileComponent,
    SurveyCommentComponent,
    SurveyGraphComponent,
    ProgressBarComponent,
    QuestionGroupCardComponent,
    QuestionGroupSelectComponent,
    MbtiTagComponent,
    CoupangAdComponent,
    BlockedCoupangAdComponent,
    RecommendContentListComponent,
    ResultSaveComponent,
    IdealTypeQuizMbtiDescriptionComponent,
    DatingStyleComponent,
    IdealTypeQuizSurveyListComponent,
    MbtiSelectComponent,
    MbtiIdealTypeSelectComponent,
    ShareLinearComponent,
    MbtiNeededComponent,
    HeaderDrawerButtonComponent,
    ScreenContainerComponent,
    HeaderBaseComponent,
    HomeHeaderComponent,
    ContentHeaderComponent,
    HeaderInstallBannerComponent,
    GoogleLoginButtonComponent,
    AppleLoginButtonComponent,
    LocaleNameInput,
    ContentBlockedCoupangAdComponent,
    DailyLogTutorialGuideMessageComponent,
    AppInstallPageLoadingComponent,
    TotalCountCounterComponent,
    DeveloperNoteComponent,
    AdsenseInarticleComponent,
    AdsenseInfeedComponent,
    ProfileLogPostComponent,
    DailyLogContentComponent,
    DailyLogContentCoverComponent,
    DailyLogContentTextComponent,
    DailyLogReactionComponent,
    DailyLogStickerReactionComponent,
    DailyLogMemoReactionComponent,
    DailyLogMemeReactionComponent,
    DailyLogEmojiReactionComponent,
    DailyLogContentEditComponent,
  ],
  imports: [SharedModule],
  exports: [
    AnswerTypeExampleComponent,
    ButtonComponent,
    ContentLoadingComponent,
    DividerComponent,
    ErrorComponent,
    FooterComponent,
    VerticalQuestionComponent,
    HorizontalQuestionComponent,
    NoticeComponent,
    PageLoadingComponent,
    PageTitleComponent,
    PercentStackedBarComponent,
    ProfileCardComponent,
    ProfileImageComponent,
    QuizReportCardComponent,
    SelectQuizReportComponent,
    HeaderComponent,
    SubtitleComponent,
    TermLinkComponent,
    MyHostQuizReportCardComponent,
    MyMbtiGuestQuizReportCardComponent,
    GnbHeaderComponent,
    MyHeaderComponent,
    ProfileEditHeaderComponent,
    HeaderHomeButtonComponent,
    FeedbackQuestionComponent,
    KakaoShareComponent,
    QuizProfileComponent,
    QuizProfileRenewalComponent,
    FeedbackComponent,
    DrawerComponent,
    LeadAppFooterComponent,
    QuestionComponent,
    SimpleTextQuestionComponent,
    SelectQuestionComponent,
    LinearQuestionComponent,
    MultiSelectQuestionComponent,
    SimpleNumberQuestionComponent,
    YearInputQuestionComponent,
    DropdownQuestionComponent,
    LinearQuestionFavourComparisonComponent,
    QuestionTickerComponent,
    PhoneInputComponent,
    InputFieldComponent,
    AskDetailComponent,
    AskContentComponent,
    AskCommentComponent,
    AskReactionComponent,
    AskProfileComponent,
    SurveyReactionComponent,
    SurveyProfileComponent,
    SurveyCommentComponent,
    SurveyGraphComponent,
    ProgressBarComponent,
    QuestionGroupCardComponent,
    QuestionGroupSelectComponent,
    MbtiTagComponent,
    CoupangAdComponent,
    BlockedCoupangAdComponent,
    RecommendContentListComponent,
    ResultSaveComponent,
    IdealTypeQuizMbtiDescriptionComponent,
    DatingStyleComponent,
    IdealTypeQuizSurveyListComponent,
    MbtiSelectComponent,
    MbtiIdealTypeSelectComponent,
    ShareLinearComponent,
    MbtiNeededComponent,
    HeaderDrawerButtonComponent,
    ScreenContainerComponent,
    HeaderBaseComponent,
    HomeHeaderComponent,
    ContentHeaderComponent,
    HeaderInstallBannerComponent,
    GoogleLoginButtonComponent,
    AppleLoginButtonComponent,
    LocaleNameInput,
    ContentBlockedCoupangAdComponent,
    DailyLogTutorialGuideMessageComponent,
    AppInstallPageLoadingComponent,
    TotalCountCounterComponent,
    DeveloperNoteComponent,
    AdsenseInarticleComponent,
    AdsenseInfeedComponent,
    ProfileLogPostComponent,
    DailyLogContentComponent,
    DailyLogContentCoverComponent,
    DailyLogContentTextComponent,
    DailyLogReactionComponent,
    DailyLogStickerReactionComponent,
    DailyLogMemoReactionComponent,
    DailyLogMemeReactionComponent,
    DailyLogEmojiReactionComponent,
    DailyLogContentEditComponent,
  ],
})
export class CommonComponentsModule {}
